import { useEffect, useState } from "react";
import axios from "axios";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = [
  {
    title: "Vibe coding: how a lawyer ships software with AI",
    body: "On building working legal products with AI — what the process actually looks like from a lawyer's chair.",
  },
  {
    title: "Legal design thinking, and principles for building",
    body: "The principles behind The Legal Buddy and LawSeek — making law usable, not just arguable.",
  },
];

const formatDate = (raw) => {
  const d = new Date(raw);
  return isNaN(d) ? "" : d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};

const Writing = () => {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    axios.get(`${API}/writing`).then((r) => setPosts(r.data.posts || [])).catch(() => setPosts([]));
  }, []);

  const live = posts && posts.length > 0;

  return (
    <section id="writing" style={{ background: "var(--canvas-soft)", borderTop: "1px solid var(--hairline)", borderBottom: "1px solid var(--hairline)" }} data-testid="writing-section">
      <div className="wrap writing-inner" style={{ padding: "88px 40px" }}>
        <Reveal>
          <div style={{ marginBottom: 40, display: "flex", alignItems: "flex-end", justifyContent: "space-between", gap: 24, flexWrap: "wrap" }}>
            <div>
              <div className="eyebrow" style={{ marginBottom: 16 }}>Writing &amp; thinking</div>
              <h2 style={{ margin: 0, fontSize: "var(--display-lg-size)", lineHeight: "var(--display-lg-lh)", letterSpacing: "var(--display-lg-ls)", fontWeight: "var(--weight-thin)", color: "var(--ink)" }}>
                Notes from building
              </h2>
            </div>
            {live && (
              <a href={posts[0].link.split("/p/")[0]} target="_blank" rel="noopener" className="link-primary" style={{ fontSize: "var(--body-md-size)", fontWeight: "var(--weight-thin)" }} data-testid="substack-link">
                Read on Substack <span className="arrow">→</span>
              </a>
            )}
          </div>
        </Reveal>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 320px), 1fr))", gap: 24 }}>
          {live
            ? posts.map((p, i) => (
                <Reveal key={p.link} delay={i * 0.06} style={{ display: "flex" }}>
                  <a href={p.link} target="_blank" rel="noopener" className="work-card" style={{ flex: 1, textDecoration: "none" }} data-testid={`writing-post-${i}`}>
                    <div style={{ fontSize: "var(--micro-cap-size)", letterSpacing: "var(--micro-cap-ls)", textTransform: "uppercase", fontWeight: 400, color: "var(--ink-mute)" }}>
                      {formatDate(p.date) || "Substack"}
                    </div>
                    <h3 style={{ margin: 0, fontSize: "var(--heading-md-size)", lineHeight: "var(--heading-md-lh)", letterSpacing: "var(--heading-md-ls)", fontWeight: 400, color: "var(--ink)" }}>{p.title}</h3>
                    <p style={{ margin: 0, flex: 1, fontSize: "var(--body-md-size)", lineHeight: 1.65, fontWeight: "var(--weight-thin)", color: "var(--ink-mute)" }}>{p.excerpt}</p>
                    <span className="link-primary" style={{ fontSize: "var(--body-md-size)", fontWeight: "var(--weight-thin)" }}>
                      Read <span className="arrow">→</span>
                    </span>
                  </a>
                </Reveal>
              ))
            : FALLBACK.map((p, i) => (
                <Reveal key={p.title} delay={i * 0.08} style={{ display: "flex" }}>
                  <div style={{ flex: 1, background: "var(--canvas)", border: "1px solid var(--hairline)", borderRadius: 12, padding: 32, display: "flex", flexDirection: "column", gap: 14 }}
                    data-testid={`writing-card-${i}`}>
                    <div style={{ fontSize: "var(--micro-cap-size)", letterSpacing: "var(--micro-cap-ls)", textTransform: "uppercase", fontWeight: 400, color: "var(--ink-mute)" }}>Coming soon</div>
                    <h3 style={{ margin: 0, fontSize: "var(--heading-md-size)", lineHeight: "var(--heading-md-lh)", letterSpacing: "var(--heading-md-ls)", fontWeight: 400, color: "var(--ink)" }}>{p.title}</h3>
                    <p style={{ margin: 0, fontSize: "var(--body-md-size)", lineHeight: 1.65, fontWeight: "var(--weight-thin)", color: "var(--ink-mute)" }}>{p.body}</p>
                  </div>
                </Reveal>
              ))}
        </div>
      </div>
    </section>
  );
};

export default Writing;
